import { useHistory } from 'react-router-dom';
import React, { useState, useRef } from 'react';

const LandingPage = ({ url }) => {
  const [shouldRemember, setShouldRemember] = useState(false);
  const history = useHistory();
  const inputRef = useRef();

  const redirect = url => {
    history.push(url,{from:"SCAN"})
  };

  const remember = ({target}) => {
    const {checked} = target;
    setShouldRemember(checked);
  };

 return (
    <div className='app-step step-1'>
      <div className="row justify-content-center">
      <div className="col-md-6">
                    <p style={{fontSize: `1rem`, textAlign: `center`,fontWeight:`400`}}>
                    The PAssion CARES initiative rewards PAssion
Members and allows them to contribute to a good cause simply by
participating in community events.</p>
<p style={{fontSize: `1rem`, textAlign: `center`,fontWeight:`400`}}>
10 yuu Points* will be contributed to community projects by
yuu Rewards Club and POSB while another 10 yuu Points will be credited to your yuu Account in appreciation of your support
towards PAssion CARES.</p>
{/* <p style={{fontSize: `1rem`, textAlign: `center`,fontWeight:`400`}}>
PAssion CARES programme is exclusive to PAssion Card Member. Please note your ID
number entered will not be stored and will be used for the sole purpose of retrieving your membership details for the PAssionCARES programme.</p>
 */}
<p style={{fontSize: `1rem`, textAlign: `center`,fontWeight:`400`}}>
By submitting, I acknowledge that I understand that PAssion CARES
initiative is exclusive to PAssion Members, I acknowledge and agree
that my ID number will be used for sole purpose of retrieving my
 PAssion Membership details, in order to submit my participation for the PAssion CARES programme
</p>
<p style={{fontSize: `1rem`, textAlign: `center`,fontWeight:`400`}}>
*Points awarded for the programme is subjected to change based on prevailing agreement with sponsors.
</p>
<div style={{ textAlign: `center`, display: `flex`, justifyContent:  `center`}}>
<input
                                ref={inputRef}
                                className="form-check-input"
                                type="checkbox"
                                id="flexCheckDefault"
                               // defaultChecked={shouldRemember}
                                onChange={remember}
                            />
                            <label
                                className="form-check-label"
                                htmlFor="flexCheckDefault"
                                style={{paddingLeft: `5px`}}
                            >  I have read and understood the terms and conditions stated above.
                            </label>
</div>
        <div className="col-md-2 m-auto" style={{paddingTop: `2rem`}}
>
          <div className="d-grid gap-2">
            <button className={`btn btn-danger btn-lg`} onClick={ () => {
              if(!shouldRemember){
                inputRef.current.focus();
                alert('Please check the checkbox to proceed.')
              } else{
                redirect(url)
              }
               }}>Continue</button>
          </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default LandingPage
